import { cloneDeep } from 'lodash'

const state = {
  toggle: false,
  items: []
}

const getters = {
  getToggle: state => state.toggle,
  getItems: state => state.items
}

const mutations = {
  UPDATE_TOGGLE: (state, boolean) => {
    state.toggle = boolean
  },
  UPDATE_ITEMS: (state, array) => {
    state.items = cloneDeep(array)
  }
}

const actions = {
  updateToggle: ({ commit, getters }, toggle) => {
    commit('UPDATE_TOGGLE', toggle)
  },
  updateItems: ({ commit }, items) => {
    commit('UPDATE_ITEMS', items)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
